import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

interface PriceListRow {
  id: string;
  name: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceListActions',
  props: {
    params: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "price-list-actions",
    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "action-btn",
      title: "Edit",
      "aria-label": "Edit price list",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.params.onEdit(_ctx.params.data)))
    }, _cache[4] || (_cache[4] = [
      _createElementVNode("i", { class: "mdi mdi-pencil" }, null, -1)
    ])),
    _createElementVNode("button", {
      type: "button",
      class: "action-btn action-btn--danger",
      title: "Delete",
      "aria-label": "Delete price list",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.params.onDelete(_ctx.params.data)))
    }, _cache[5] || (_cache[5] = [
      _createElementVNode("i", { class: "mdi mdi-delete" }, null, -1)
    ])),
    (_ctx.params.showExport)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "action-btn",
          title: "Export to Excel",
          "aria-label": "Export price list to Excel",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.params.onExport(_ctx.params.data)))
        }, _cache[6] || (_cache[6] = [
          _createElementVNode("i", { class: "mdi mdi-file-excel" }, null, -1)
        ])))
      : _createCommentVNode("", true)
  ]))
}
}

})